<template>
    <div class="px-4" v-if="refresh">
        <div class="text-12 lg:text-14 text-a-brown-9f8273 text-center py-4">* {{lbl.tax.please_fill_out}}</div>
        <InputText
            v-model:inputValue="addressModel.taxName"
            :maxLength="50"
            :errorInfo="errorInfo[0]"
            :isShowError="false"
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.tax.companyName"
        ></InputText>
        <InputNationalId
                key="input-address-taxid"
                v-model:inputValue="addressModel.taxId"
                :errorInfo="errorInfo[1]"
                :maxLength="20"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.nationalid"
        ></InputNationalId>
        <InputContactNumber
                key="input-address-contactnumber"
                v-model:inputValue="addressModel.contactNumber"
                :minLength="12"
                :maxLength="12"
                delimeter="-"
                :errorInfo="errorInfo[2]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.contactnumber"
        ></InputContactNumber>
        <div class="lg:text-24 font-bold text-a-brown-502314 border-t border-a-brown-d7c7b8 py-6 text-center">{{lbl.tax.address_tax}}</div>
        <FormAddressDropdown
                v-model:inputValue="formAddressModel"
                :errorInfo="errorInfo[3]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax"
        ></FormAddressDropdown>
        <InputTextarea
                key="input-address-building"
                v-model:inputValue="addressModel.taxDetail"
                :maxLength="300"
                :errorInfo="errorInfo[4]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.tax.building"
        ></InputTextarea>
        <Checkbox
                v-model:check="addressModel.isDefaultTax"
                :text="lbl.tax.isDefaultTax"
        ></Checkbox>
    </div>
</template>
<script>
// import Util from '@/helper/Utility.js';
import { FormHelper } from '@/helper/FormHelper.js';
//component
import InputText from '@/components/Input/label/InputText.vue';
import InputTextarea from '@/components/Input/label/InputTextarea.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import FormAddressDropdown from '@/components/Form/FormAddressDropdown.vue';
// import InputRadio from '@/components/Input/label/InputRadio.vue';
import InputNationalId from '@/components/Input/label/InputNationalId.vue';
import Checkbox from "@/components/Input/simple/Checkbox.vue";
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//service
import { AddressModel } from '@/core/Address/model/AddressModel.js';
import { AddressListModel } from '@/core/Address/model/AddressListModel.js';

export default {
    name: 'FormTaxAddress',
    inject: ['DeliveryStore'],
    mixins: [LocaleMixin,ModalMixin],
    components: {
        InputText,
        InputTextarea,
        InputContactNumber,
        FormAddressDropdown,
        // InputRadio,
        InputNationalId,
        Checkbox
    },
    data: function() {
        return {
            personTypeValue: [],
            prefixValue: [],
            isSubmitted: false,
            errorInfo: [],
            refresh: true,

            formAddressModel: new AddressModel(),
            addressModel: null,
        };
    },
    created: function() {
        this.initForm(this.DeliveryStore.state.taxAddress);
        this.setupFormValue();

    },
    methods: {
        initForm: function(address) {
            this.isSubmitted = false;

            if (address != null) {
                this.addressModel = {...address};
                this.formAddressModel.setValueFromAddressListModel(this.addressModel);
            } else {
                this.addressModel = new AddressListModel();
                // this.formAddressModel = new AddressModel();
            }


            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },
        setupFormValue: function() {
            this.errorInfo = FormHelper.genErrorInfo(5);

            // var personType = new DropdownListValue();
            // personType.add("บุคคลธรรมดา", "individual");
            // personType.add("นิติบุคคล", "company");
            // this.personTypeValue = personType.getList();

            // var prefixValue = new DropdownListValue();
            // prefixValue.add("นาย", "mr");
            // prefixValue.add("นางสาว", "ms");
            // prefixValue.add("นาง", "mss");
            // this.prefixValue = prefixValue.getList();
        },
        clearForm: function() {
            this.initForm(null);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                this.addressModel.setValueFromAddressModel(this.formAddressModel);
                this.addressModel.setIsTax();
                this.addressModel.lat = "0";
                this.addressModel.lng = "0";
                return this.addressModel;
            } else {
                this.modal.errorModal.clearModal()
                                    .setMsg(FormHelper.getFirstErrorItem(this.errorInfo).msg)
                                    .show();
            }
            return null
        },
        validate: function() {
            return FormHelper.validate(this.errorInfo);
            //  for (let i=0 ; i<17 ; i++) {
            //     if (this.addressModel.personType == 'individual') {
            //         if (i == 4) {
            //             continue;
            //         }
            //     } else if (this.addressModel.personType == 'company') {
            //         if (i >= 1 && i <= 3) {
            //             continue;
            //         }
            //     }

            //     if (!this.errorInfo[i].isValid) {
            //         return false;
            //     }
            // }

            // return true;
        },
    },
}
</script>
